import { render, staticRenderFns } from "./VideoManager.vue?vue&type=template&id=4e7f22d4&scoped=true"
import script from "./VideoManager.vue?vue&type=script&lang=js"
export * from "./VideoManager.vue?vue&type=script&lang=js"
import style0 from "./VideoManager.vue?vue&type=style&index=0&id=4e7f22d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7f22d4",
  null
  
)

export default component.exports